import type { StorageLocationsOverviewParams } from 'src/apis/storage/types';

export const storageLocationsEmptyParams: StorageLocationsOverviewParams = {
  limit: 0, // we just need the create link
};

export const MAX_MARKET_AREAS = 2;
